import * as React from 'react'
import { requestPost, } from '../../../../../modules/request'

const EmailVerification = () => {
  function verifyEmail() {
    requestPost(`${window.postbuildEnv.DEFAULT_URL}/verify_emails/require_email_verification`, { email_redirect_url: window.location.href }, (body) => {
      if (body.redirect) {
        window.location.href = body.redirect
      } else {
        window.location.reload()
      }
    })
  }

  return (
    <div className="email-verification">
      <h2>Verify your email to access Diagnostic Insights</h2>
      <p>Diagnostic Insights gives you a comprehensive view of each student’s progress, helping you understand which diagnostics they’ve completed and
what to assign next based on their performance history. To access this feature, we need to verify your email to confirm your role.</p>
      <button className="quill-button contained medium green focus-on-light" onClick={verifyEmail} type="button">Verify my email</button>
    </div>
  )
}

export default EmailVerification
